import { fileTypeMeta } from "./fileTypes";

export interface FileGlyphProps {
  fileName: string;
  fileType: string;
  /** `md` (lists) ≈ 44px, `sm` (headers) ≈ 36px. */
  size?: "sm" | "md";
}

/** Coloured file-type glyph with a folded corner and the extension label. */
export function FileGlyph({ fileName, fileType, size = "md" }: FileGlyphProps) {
  const { badge, color } = fileTypeMeta(fileName, fileType);
  const box = size === "sm" ? "size-9" : "size-11";
  const fold =
    size === "sm" ? "border-l-[10px] border-t-[10px]" : "border-l-[12px] border-t-[12px]";
  const text = size === "sm" ? "text-[9px]" : "text-[10px]";
  return (
    <span
      aria-hidden
      className={`relative grid ${box} shrink-0 place-items-center overflow-hidden rounded-lg`}
      style={{ backgroundColor: color }}
    >
      <span
        className={`absolute right-0 top-0 size-0 ${fold} border-l-transparent`}
        style={{ borderTopColor: "rgba(255,255,255,0.35)" }}
      />
      <span className={`${text} font-bold tracking-wide text-white`}>{badge}</span>
    </span>
  );
}
